import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";
import { Link, useLocation, useParams, useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import { GeographicalStatisticsObject } from "./types";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";
import FooterText from "src/components/footerText";
import CaseVolume from "src/components/manufacturer/caseVolumeLineChart";
import GeographicalStatistics from "src/components/manufacturer/geographicalStatistics";
import CaseFilter from "src/components/manufacturer/statistics";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import {AuthContext} from "../../context/authContext";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import CustomTopPayorDetail from "src/components/manufacturer/customTopPayorDetail";
import CustomComponentForTransfer from "src/components/manufacturer/customComponentForTransfer";
import CustomComponentForPriorAuth from "src/components/manufacturer/customComponentPriorAuth";
import { StatisticsApiResponse } from "../manufacturer/types";
import { objectToQueryString } from "src/helpers";


const TBMs: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData } = useContext(AuthContext);
  const [searchParams, updateSearchParams] = useSearchParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const insuranceName:string | null = params.get('insurance_name');
  const { role,id, } = useParams();


  const [queryParams, changeQueryParams] = useState({
    start_date:
      searchParams.get("start_date") ||
      format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
    end_date:
      searchParams.get("end_date") ||
      format(new Date().setDate(new Date().getDate()+1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "",
    filter_type: searchParams.get("filter") || "",
    // time: searchParams.get("time") || "",
    type: searchParams.get("id") === (userData ? userData.id.toString() : "") ? "index" : "",
    soc_value:searchParams.get("soc_value") || "",
    drug_id:searchParams.get("drug_id") || "",
    user_id: searchParams.get("user_id") || (userData && userData.ref_type === "rep" ? userData.id.toString() : "") || "",
    insurance_name:insuranceName,
    case_filter: "",
    age_group: searchParams.get("age_group") || "all",
    search_str: "",
    role: role || searchParams.get("role") || userData?.ref_type || "",
    id: id || "",
  });

  const { data: statisticsData, mutate: getStatsData } = 
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);



  const updateQueryParamsAndCallAPI = (
    updatedQueries: StatisticsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate()),
          "yyyy-MM-dd"
        ),
        period: "",
        filter_type: "",
        // time: "",
        type: "",
        soc_value:"",
        drug_id:"",
        user_id: "",
        insurance_name:'',
        case_filter: "",
        age_group: "all",
        search_str: "",
        role: "",
        id: "",
      });
    } else {
      changeQueryParams(updatedQueries);
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = () => {
    const updatedQueries = {
      ...queryParams,
     
    } 
    changeQueryParams(updatedQueries)
    getStatsData({}, {}, updatedQueries);
  }

  return (
    <div className="container-fluid overflow-auto">
      <AuthMaunfacturerSubHeader/>
      {statisticsData && (
        <CaseFilter
          defaultQueryParams={queryParams}
          updateQueryParams={updateQueryParamsAndCallAPI}
        />
      )}
      {statisticsData && (
        <CaseVolume StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData} buttonShows={true} />
      )}
      {statisticsData && (
        <CustomTopPayorDetail StatisticsObjectType={statisticsData.data} />
      )}

      {statisticsData && (
        <CustomComponentForTransfer StatisticsObjectType={statisticsData.data} />
      )}

       {statisticsData && (
        <CustomComponentForPriorAuth StatisticsObjectType={statisticsData.data} />
      )}

      {statisticsData && (
        // <CustomComponentAreaCaseBySubmission StatisticsObjectType={statisticsData.data} title={'Reps'}/>
         <div className="col-12 col-lg-12 mb-3">
                <div className="card">
                  <div className="card-header">
                    <h1 className="m-0 text-center">TBMs
                    </h1>
                  </div>
                  <div className="card-body p-0" style={{maxHeight:'500px', overflow:'auto'}}>
                    <table className="table table-responsive table-hover">
                      <thead className="table-light sticky-top">
                        <tr className="text-center">
                          <th className="text-white">Name</th>
                          <th className="text-white">Cases</th>
                        </tr>
                      </thead>
                      <tbody>
                        {statisticsData.data.tbms &&
                          statisticsData.data.tbms.data &&
                          statisticsData.data.tbms.data.length > 0 &&
                          statisticsData.data.tbms.data.map((item, key) => (
                            <tr className="text-center" key={key}>
                              <td>
                                <Link
                                  to={{
                                    pathname: `/statistics/${item.id}`,
                                    search: objectToQueryString(
                                      queryParams
                                        ? {
                                            start_date: queryParams.start_date,
                                            end_date: queryParams.end_date,
                                            period: queryParams.period,
                                            filter_type: queryParams.filter_type,
                                            case_filter: queryParams.case_filter,
                                            age_group: queryParams.age_group,
                                            role: userData?.ref_type,
                                            id: item.id
                                          }
                                        : {}
                                    ),
                                  }}
                                  className="p-0 btn btn-link"
                                >
                                  {item.name}
                                </Link>
                              </td>
                              <td>{item.cases || ""}</td>
                            </tr>
                          ))}
                      </tbody>
                      <tfoot>
                        <tr className="text-center">
                          <td className="fw-bold">Total</td>
                          <td className="fw-bold">{statisticsData.data.tbms?.total}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
      )}
      
      {statisticsData?.data && (
        <GeographicalStatistics
          GeographicalStatisticsListType={
            statisticsData?.data
              .geographical_stats as unknown as GeographicalStatisticsObject[]
          }
        />
      )}
      <FooterText footerType="black" />
    </div>
  );
};

export default TBMs;
